import { FaCheck, FaRegTrashCan } from "react-icons/fa6"
import { FiCreditCard, FiEdit3, FiMapPin, FiPackage, FiPlus, FiPrinter, FiUser } from "react-icons/fi"
import { MdClose } from "react-icons/md"

import { maskCurrency } from "../../utils/utils"
import '../Modals/OrderIfood/style.css'
import { LIST_STATUS } from "../../utils/constantes";

function ProductItem({ product, pending, calculateProductTotal, onRemove, onPrint, onSetSeen }) {
  const additionals = Object.values(product?.additinal || {}).flat()

  return (
    <article className={`ifood-item standard-order-item ${pending ? 'pending' : ''}`}>
      <div className="ifood-item-main">
        <span className="ifood-item-quantity">{product.quantity}x</span>
        <div className="ifood-item-description">
          <strong>{product.name || product.nameProduct}</strong>
          <span>Unitário: {maskCurrency(product.pricing || 0)}</span>
        </div>
        <strong className="ifood-item-price">{maskCurrency(calculateProductTotal(product) * product.quantity)}</strong>
        <div className="standard-order-item-actions">
          {!pending && <button type="button" title="Imprimir item" aria-label="Imprimir item" onClick={() => onPrint(product)}><FiPrinter /></button>}
          {!pending && onSetSeen && <button type="button" className={product.isSeen ? 'seen' : 'not-seen'} title={product.isSeen ? 'Item visualizado' : 'Marcar como visualizado'} aria-label={product.isSeen ? 'Item visualizado' : 'Marcar como visualizado'} onClick={() => !product.isSeen && onSetSeen(product.id)}>{product.isSeen ? <FaCheck /> : <MdClose />}</button>}
          <button type="button" className="remove" title="Remover item" aria-label="Remover item" onClick={() => onRemove(product.id)}><FaRegTrashCan /></button>
        </div>
      </div>

      {additionals.length > 0 && (
        <div className="ifood-item-options">
          {additionals.map((additional, index) => (
            <div key={`${additional.id || additional.name}-${index}`}>
              <span>{additional.quantity}x {additional.name}</span>
              <span>{maskCurrency(additional.pricing)}</span>
            </div>
          ))}
        </div>
      )}

      {(product.observation || product.observations) && (
        <div className="ifood-item-note"><strong>Observação:</strong> {product.observation || product.observations}</div>
      )}
    </article>
  )
}

export function OrderOverview({
  order,
  pendingProducts = [],
  calculateProductTotal,
  onAddItems,
  onPrintOrder,
  onEditCustomer,
  onOpenPayments,
  onConfirmPending,
  onRemovePending,
  onRemoveProduct,
  onPrintProduct,
  onSetSeen,
  canEdit = true,
  sidebarHeader,
  hideSummary = false,
  tableMode = false,
}) {
  const products = order?.productsOrders || []
  const deliveryFee = order?.deliveryDistrict?.free ? 0 : Number(order?.deliveryDistrict?.pricing || 0)
  const discount = Number(order?.discount || 0)
  const extra = Number(order?.extra || 0)
  const paid = order?.payments?.reduce((total, payment) => total + Number(payment.pricing || 0), 0) || 0
  const remaining = Math.max(Number(order?.total || 0) - paid, 0)

  if (!order || !order?.status) {
    return <></>
  }

  return (
    <div className={`standard-order-overview ${tableMode ? 'table-order-overview' : ''}`}>
      <section className="ifood-customer-card standard-customer-card">
        <button type="button" className="ifood-customer-name standard-customer-button" onClick={onEditCustomer}>
          <span><FiUser size={17} /></span>
          <div><small>Cliente</small><strong>{order?.name || 'Cliente não informado'}</strong></div>
          <FiEdit3 className="standard-customer-edit" />
        </button>

        <div className="ifood-order-facts" style={{ fontWeight: '600' }}>
          {order?.numOrder && <div><small>Pedido</small><span>#{order.numOrder}</span></div>}
          <div><small>Tipo</small><span >{order?.typeOrder === 'mesa' ? 'Mesa / comanda' : order?.methodDelivery === 'entrega' ? 'Entrega' : 'Retirada'}</span></div>
          <div><small>Status</small><span className="standard-order-status">{LIST_STATUS.find(e => e.status === order.status)?.name || order.status || 'Em aberto'}</span></div>
        </div>

        {(order?.address || order?.methodDelivery === 'retirada') && (
          <div className="ifood-address">
            <FiMapPin size={17} />
            <div>
              <small>{order?.methodDelivery === 'retirada' ? 'Forma de entrega' : 'Endereço de entrega'}</small>
              <strong>{order?.methodDelivery === 'retirada' ? 'Retirada no local' : `${order.address || ''}${order.number ? `, ${order.number}` : ''}`}</strong>
              {order?.complement && <span>Complemento: {order.complement}</span>}
            </div>
          </div>
        )}
      </section>

      <div className="ifood-content-grid standard-order-grid">
        <section className="ifood-section ifood-items-section">
          <div className="ifood-section-title standard-section-title">
            <FiPackage size={17} />
            <h6>Itens do pedido</h6>
            <span>{products.length + pendingProducts.length}</span>
            <div className="standard-section-actions">
              {canEdit && <button type="button" className="primary" onClick={onAddItems}><FiPlus /> Adicionar itens</button>}
              {onPrintOrder && <button type="button" onClick={onPrintOrder}><FiPrinter /> Imprimir</button>}
            </div>
          </div>

          {pendingProducts.length > 0 && (
            <div className="standard-pending-block">
              <div className="standard-pending-heading">
                <div><strong>Itens não confirmados</strong><span>{pendingProducts.length} {pendingProducts.length === 1 ? 'item aguardando' : 'itens aguardando'}</span></div>
                <button type="button" onClick={onConfirmPending}><FaCheck /> Confirmar todos</button>
              </div>
              {pendingProducts.map(product => <ProductItem key={product.id} product={product} pending calculateProductTotal={calculateProductTotal} onRemove={onRemovePending} />)}
            </div>
          )}

          <div className="ifood-items-list">
            {products.map(product => <ProductItem key={product.id} product={product} calculateProductTotal={calculateProductTotal} onRemove={onRemoveProduct} onPrint={onPrintProduct} onSetSeen={onSetSeen} />)}
            {products.length === 0 && pendingProducts.length === 0 && <div className="standard-items-empty"><FiPackage /><strong>Nenhum item adicionado</strong><span>Use “Adicionar itens” para começar o pedido.</span></div>}
          </div>
        </section>

        <aside className="ifood-order-sidebar standard-order-sidebar">
          {sidebarHeader}

          {!hideSummary && (
            <section className="ifood-section">
              <div className="ifood-section-title"><FiCreditCard size={17} /><h6>Resumo</h6></div>
              <div className="ifood-totals">
                {deliveryFee > 0 && <div><span>Taxa de entrega</span><strong>{maskCurrency(deliveryFee)}</strong></div>}
                {discount > 0 && <div className="discount"><span>Desconto</span><strong>- {maskCurrency(discount)}</strong></div>}
                {extra > 0 && <div><span>Acréscimo</span><strong>{maskCurrency(extra)}</strong></div>}
                <div className="total"><span>Total do pedido</span><span style={{ fontWeight: '600' }}>{maskCurrency(order?.total || 0)}</span></div>
              </div>
            </section>
          )}

          <section className="ifood-section standard-payment-card">
            <div className="ifood-section-title"><FiCreditCard size={17} /><h6>Pagamento</h6></div>
            <button type="button" className="standard-payment-content" onClick={onOpenPayments} disabled={!canEdit}>
              {paid > 0 ? (
                <><div><span className={remaining === 0 ? 'paid' : 'pending'}>{remaining === 0 ? <FaCheck /> : <FiCreditCard />}</span><div><strong>{remaining === 0 ? 'Pagamento concluído' : 'Pagamento parcial'}</strong><small>{order.payments.length} {order.payments.length === 1 ? 'pagamento lançado' : 'pagamentos lançados'}</small></div></div><strong>{maskCurrency(paid)}</strong></>
              ) : (
                <div style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <FiCreditCard color="#f97316" size={20} />
                  </div>
                  <div style={{ width: '100%' }}>
                    <span style={{ fontWeight: '600' }}>Pagamento não lançado</span>
                  </div>
                  <div>
                    <FiEdit3 color="#6666" size={20} />
                  </div>
                </div>
              )}
            </button>
          </section>
        </aside>
      </div>
    </div>
  )
}
